"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepositions = exports.FEEDBACK_SOUNDS = void 0;
exports.FEEDBACK_SOUNDS = {
    1: {
        correct: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/correct_ru.mp3",
        incorrect: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/incorrect_ru.mp3",
        diamond: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Diamond_ru.mp3",
        rubin: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Rubin_ru.mp3",
        coin: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Coin_ru.mp3",
        manyMistakes: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Many_ru.mp3",
        normal: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Normal_ru.mp3",
        super: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Super_ru.mp3",
        good: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Good_ru.mp3",
    },
    2: {
        correct: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/correct.mp3",
        incorrect: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/incorrect.mp3",
        diamond: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Diamond.mp3",
        rubin: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Ruby.mp3",
        coin: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Coin.mp3",
        manyMistakes: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Many.mp3",
        normal: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Normal.mp3",
        super: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Super.mp3",
        good: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Good.mp3",
    },
    5: {
        correct: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Correct-uz.mp3",
        incorrect: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Incorrect-uz.mp3",
        diamond: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Diamond-uz.mp3",
        rubin: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Ruby-uz.mp3",
        coin: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Coin_uz.mp3",
        manyMistakes: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Many_uz.mp3",
        normal: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Normal_uz.mp3",
        super: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Super-uz.mp3",
        good: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Good_uz.mp3",
    },
    6: {
        correct: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Correct-kz.mp3",
        incorrect: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Incorrect-kz.mp3",
        diamond: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Diamond-kz.mp3",
        rubin: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Ruby-kz.mp3",
        coin: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Coin-kz.mp3",
        manyMistakes: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Many-kz.mp3",
        normal: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Normal-kz.mp3",
        super: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Super-kz.mp3",
        good: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_effects/Good-kz.mp3",
    },
};
exports.prepositions = [
    "в", "на", "с", "о", "об", "у", "к", "по", "из", "от", "до",
    "через", "при", "под", "над", "за", "для", "без", "перед", "и",
    "между", "около", "после", "вокруг", "внутри", "вне", "среди"
];
